import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Mail, Phone } from "lucide-react";

export function ManagerCard() {
  const [m, setM] = useState(null);
  useEffect(() => { api.get("/care-home/manager-card").then((r) => setM(r.data)).catch(() => {}); }, []);
  if (!m?.name) return null;
  return (
    <div data-testid="manager-card" className="mb-6 rounded-2xl bg-cream-card border border-cream-deep px-4 py-3 flex items-center gap-4">
      <div className="h-12 w-12 rounded-full bg-brand/10 overflow-hidden grid place-items-center shrink-0">
        {m.photo_url ? <img src={m.photo_url} alt={m.name} className="h-full w-full object-cover" /> : <span className="font-heading font-bold text-brand">{m.name.split(" ").map((w) => w[0]).slice(0, 2).join("")}</span>}
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[11px] uppercase tracking-wider text-muted-foreground font-semibold">Your manager</div>
        <div className="font-heading font-bold text-brand truncate">{m.name}</div>
      </div>
      <div className="hidden sm:flex flex-col items-end text-xs text-muted-foreground gap-0.5">
        {m.email && <a href={`mailto:${m.email}`} className="flex items-center gap-1 hover:text-brand"><Mail className="h-3 w-3" />{m.email}</a>}
        {m.phone && <span className="flex items-center gap-1"><Phone className="h-3 w-3" />{m.phone}</span>}
      </div>
    </div>
  );
}
